'use client'
export * from './log'
export * from './fakeData'
export * from './constants'
export * from './copyLink'

export const shortenAddress = (address: string, chars = 4): string => {
  if (!address) return ''
  return `${address.slice(0, chars + 2)}...${address.slice(-chars)}`
}

export const handleShowMessage = (message: any) => {
  if (Array.isArray(message)) {
    return message[0]
  }
  return message
}
